const ErrorCode = {
    'NO_DATA_FOUND': {code: 1001},
    'MISSING_PARAMETER': {code: 1002},
    'INVALID_PARAMETER': {code: 1003},
    'INVALID_AUTHENTICATION': {
        code: 1004,
        silent: true
    },
    'NOT_AUTHORIZED': {code: 1007},
    'VALIDATION_FAILED': {code: 1009},
    'ACCOUNT_NOT_CONFIRMED': {
        code: 1010,
        silent: true
    },
    'BALANCE_INSUFFICIENT': {code: 1011},
    'DATA_ALREADY_EXISTS': {
        code: 1012,
        silent: true
    },
    'ACCOUNT_ALREADY_CONFIRMED': {
        code: 1013,
        silent: true
    },
    'CLUB_DOES_NOT_EXIST': {
        code: 1018,
        silent: true
    },
    'ACCOUNT_NOT_ACTIVATED': {code: 1019},
    'CLUB_NOT_ACTIVE': {code: 1021},
    'CAPTCHA_INVALID': {
        code: 1022,
        silent: true
    },
    'NOT_SUPPORTED_IN_FREE_VERSION': {
        code: 1023,
        silent: true
    },
    'WRONG_TOKEN': {code: 1014},
    'NO_PERMISSION_TO_CREATE_TEAM_IN_CSV': {code: 10003},
    'MISSING_CSV_HEADER_END_TIME': {code: 10004},
    'MISSING_CSV_HEADER_IDX': {code: 10005},
    'INVALID_FILE_FORMAT': {code: 10006},
    'UNPROCESSABLE_CELL_VALUE_TIME': {code: 10007},
    'UNKNOWN_HEADER_FOUND': {code: 10008},
    'NO_HEADERS_FOUND': {code: 10009},
    'NO_DATA_IN_FILE': {code: 10010},
    'DATE_FORMAT_NOT_PARSABLE': {code: 10011},
    'TEAM_REF_IN_ENTITIES': {code: 10012},
    'MISSING_CSV_HEADER_NAME': {code: 10013}
};

export default ErrorCode;
